import moment from "moment";
import { IUserActivityLogs } from "../models/logs.model";

export type DeviceType = 'Mobile' | 'Desktop' | 'Ipad' | 'Tablet';

export class LogsUtility {
  //#region get OS information
  private getOS(): string {
    let userAgent = navigator.userAgent;
    // Check if the user is using Windows
    if (userAgent.includes('Windows')) {
      return 'Windows';
    } // iphone os
    else if (userAgent.includes('iphone')) {
      return 'iPhone OS';
    }
    // Check if the user is using Mac
    else if (userAgent.includes('Macintosh') || userAgent.includes('Mac')) {
      return 'MacOS';
    }
    // Check if the user is using android
    else if (userAgent.includes('Android')) {
      return 'Android';
    } // Check if the user is using ubuntu
    else if (userAgent.includes('Ubuntu')) {
      return 'Ubuntu';
    }
    // Check if the user is using Linux
    else if (userAgent.includes('Linux')) {
      return 'Linux';
    }
    // If none of the above, assume an unknown operating system
    else {
      return 'Unknown';
    }
  }

  private getOSVersion(): string {
    let userAgent = navigator.userAgent;
    // Check if the user is using Windows and extract the version
    if (navigator.userAgent.indexOf('Windows') !== -1) {
      const match = /Windows NT (\d+\.\d+)/.exec(userAgent);
      if (match) {
        const windowsVersion = parseFloat(match[1]);
        return windowsVersion.toString();
      }
      return 'NA';
    }
    // Check if the user is using macOS and extract the version
    else if (userAgent.indexOf('Macintosh') !== -1) {
      const match = /Mac OS X (\d+[\._]\d+)/.exec(userAgent);
      if (match) {
        const macVersion = match[1].replace('_', '.');
        return macVersion.toString();
      }
      return 'NA';
    }
    // Check if the user is using iPad and extract the version
    else if (userAgent.indexOf('iPad') !== -1) {
      const match = /CPU OS (\d+[\._]\d+)/.exec(userAgent);
      if (match) {
        const macVersion = match[1].replace('_', '.');
        return macVersion.toString();
      }
      return 'NA';
    }
    // Check if the user is using iPhone and extract the version
    else if (userAgent.indexOf('iPhone') !== -1) {
      const match = /iPhone OS (\d+[\._]\d+)/.exec(userAgent);
      if (match) {
        const macVersion = match[1].replace('_', '.');
        return macVersion.toString();
      }
      return 'NA';
    } // Check if the user is using android and extract the version
    else if (userAgent.indexOf('Android') !== -1) {
      const match = /Android (\d+[\._]\d+)/.exec(userAgent);
      if (match) {
        const macVersion = match[1].replace('_', '.');
        return macVersion.toString();
      }
      return 'NA';
    }
    // Check if the user is using Linux
    else if (userAgent.indexOf('Linux') !== -1) {
      return 'NA';
    }
    // If none of the above, assume an unknown operating system
    else {
      return 'Unknown';
    }
  }
  //#endregion

  //#region get browser information
  private testRegexp = (regexp: RegExp) => {
    return regexp.test(navigator.userAgent);
  };

  public getBrowserType() {
    if (this.testRegexp(/opr\//i)) {
      return 'Opera';
    } else if (this.testRegexp(/edg/i)) {
      return 'Microsoft Edge';
    } else if (this.testRegexp(/chrome|chromium|crios/i)) {
      return 'Google Chrome';
    } else if (this.testRegexp(/firefox|fxios/i)) {
      return 'Mozilla Firefox';
    } else if (this.testRegexp(/safari/i)) {
      return 'Apple Safari';
    } else if (this.testRegexp(/trident/i)) {
      return 'Microsoft Internet Explorer';
    } else if (this.testRegexp(/ucbrowser/i)) {
      return 'UC Browser';
    } else if (this.testRegexp(/samsungbrowser/i)) {
      return 'Samsung Browser';
    } else {
      return 'Unknown browser';
    }
  }

  public getDeviceType(): DeviceType {
    if (
      this.testRegexp(/Android|iPhone|iPod|BlackBerry|BB|IEMobile|Opera Mini/i)
    ) {
      return 'Mobile';
    } else if (this.testRegexp(/iPad|Macintosh/i)) {
      return 'Ipad';
    } else if (this.testRegexp(/Tablet/i)) {
      return 'Tablet';
    } else {
      return 'Desktop';
    }
  }
  //#endregion

  //#region update user logs
  public updateUserLogs(
    currentUser: {name: string, userEmail: string} | null,
    userLogs: IUserActivityLogs,
    eventType: Event,
    id?: string,
    customerId?: string,
    dto?: Record<string, string> 
  ): IUserActivityLogs {
    // console.log(window.location);
    // userLogs.userID = userLogs.userID ? userLogs.userID : '1';
    userLogs.userName = 'Mukesh salaria';
    userLogs.userEmail = 'salaria01@gmail.com'
    // userLogs.eventCategory = eventType;
    userLogs.url = window.location.href;
    userLogs.deviceType = this.getDeviceType();
    userLogs.browser = this.getBrowserType();
    userLogs.toDate = moment().format('MMMM Do YYYY, h:mm:ss a');
    userLogs.city = 'Mohali';
    userLogs.country = 'India';
    //   JSON.parse(localStorage.getItem('user') as string)?.sessionID ?? '';
    // id && (userLogs.loanApplicationUniqueId = id);
    userLogs.description = dto?.description;
    userLogs.operatingSystem = this.getOS();
    // userLogs.operatingSystemVersion = this.getOSVersion();
    // userLogs.service = 'LoanApplicationService';
    return userLogs;
  }
  // #end region
}
